import { MyContactHelpdesk } from './myContactHelpdesk';

require('./myContactHelpdesk.scss');

export const myContactHelpdeskComponent = {
  template: require('./myContactHelpdesk.html'),
  controllerAs: 'ctrl',
  controller: MyContactHelpdesk,
};
